import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    accesorios: {
        comfort: [],
        seguridad: [],
        exterior: [],
        multimedia: [],
    },
};
const mutations = {
    updateField,
    updateAccesorios: (state, payload) =>{
        state.accesorios = payload;
    },
    updateFromReporte: (state, payload) => {
        if(payload.inspeccion_mecanica){
            const {accesorios} = payload.inspeccion_mecanica;
            state.accesorios = accesorios;
        }else{
            state.accesorios.comfort = payload.comfort;
            state.accesorios.seguridad = payload.seguridad;
            state.accesorios.exterior = payload.exterior;
            state.accesorios.multimedia = payload.multimedia;
        }
    },
    updateComfort: (state, payload) =>{
        state.accesorios.comfort = payload;
    },
    updateseguridad: (state, payload) =>{
        state.accesorios.seguridad = payload;
    },
    updateexterior: (state, payload) =>{
        state.accesorios.exterior = payload;
    },
    updatedmultimedia: (state, payload) =>{
        state.accesorios.multimedia = payload;
    }
};

const getters = {
    getField
};

export default {
    namespaced: true,
    state,
    mutations,
    getters
}
